import axios from 'axios'

import { getToken } from './auth'

const API_URL = process.env.REACT_APP_API_URL || ''

class FetchData {
  static async userProfile() {
    const token = getToken()

    if (!token) return null

    const { data } = await axios.get(`${API_URL}/user/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    })

    return data
  }

  static async feedFaq(categories) {
    const { data } = await axios.get(`${API_URL}/chats/feedFaq`, {
      params: { categories },
    })

    return data
  }
}

export default FetchData
